export default __webpack_public_path__ + "static/media/cuerpo-hombre-piel-amarilla.a83f3f31.png";